import React, { useState, useEffect } from "react";
import {
  FaBox,
  FaDollarSign,
  FaPlusCircle,
  FaSpinner,
  FaEdit,
  FaTrash,
  FaSave,
  FaEllipsisV,
  FaArrowLeft,
  FaList
} from "react-icons/fa";
import API_URL from "../config";
import "./Product.css";

export default function Product({ entrepriseId, siteId }) {
  const [nom, setNom] = useState("");
  const [prix, setPrix] = useState("");
  const [loading, setLoading] = useState(false);
  const [produits, setProduits] = useState([]);
  const [loadingProduits, setLoadingProduits] = useState(true);
  const [error, setError] = useState(null);
  const [editId, setEditId] = useState(null);

  const [view, setView] = useState("form"); 
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    fetchProduits();
  }, [entrepriseId, siteId]);

  const fetchProduits = async () => {
    if (!entrepriseId || !siteId) return;
    try {
      setLoadingProduits(true);
      const response = await fetch(
        `${API_URL}/api/produits?entrepriseId=${entrepriseId}&siteId=${siteId}`
      );
      if (!response.ok) throw new Error("Erreur de chargement");
      const data = await response.json();
      setProduits(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingProduits(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nom || !prix) { alert("⚠️ Champs vides"); return; }
    try {
      setLoading(true);
      const method = editId ? "PUT" : "POST";
      const url = editId ? `${API_URL}/api/produits/${editId}` : `${API_URL}/api/produits`;
      
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nom, prix_unitaire: prix, entrepriseId, siteId }),
      });

      if (!response.ok) throw new Error("Erreur");
      setNom(""); setPrix(""); setEditId(null);
      fetchProduits();
      setView("list");
    } catch (err) {
      alert("❌ Erreur");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (p) => {
    setEditId(p.id); setNom(p.nom); setPrix(p.prix_unitaire);
    setView("form");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ?")) return;
    try {
      await fetch(`${API_URL}/api/produits/${id}?entrepriseId=${entrepriseId}&siteId=${siteId}`, { method: "DELETE" });
      fetchProduits();
    } catch (err) { alert("Erreur"); }
  };

  return (
    <div className="product-page">
      {/* Barre de navigation fixe en haut */}
      <div className="top-bar">
        {view === "list" ? (
          <button className="back-btn" onClick={() => setView("form")}>
            <FaArrowLeft /> Retour
          </button>
        ) : <div className="spacer"></div>}
        
        <h1 className="page-title">{view === "form" ? "Nouveau Produit" : "Liste Produits"}</h1>

        <div className="menu-container">
          <button className="menu-dots" onClick={() => setShowMenu(!showMenu)}>
            <FaEllipsisV />
          </button>
          {showMenu && (
            <div className="menu-dropdown" onClick={() => setShowMenu(false)}>
              <div className="menu-item" onClick={() => setView(view === "form" ? "list" : "form")}>
                {view === "form" ? <><FaList /> Voir la liste</> : <><FaPlusCircle /> Ajouter</>}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Affichage direct dans le flux du body */}
      {view === "form" ? (
        <form onSubmit={handleSubmit} className="product-form">
          <div className="form-group">
            <label>Nom du produit</label>
            <div className="input-wrapper">
              <FaBox className="input-icon" />
              <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Nom..." />
            </div>
          </div>
          <div className="form-group">
            <label>Prix (FCFA)</label>
            <div className="input-wrapper">
              <FaDollarSign className="input-icon" />
              <input type="number" value={prix} onChange={(e) => setPrix(e.target.value)} placeholder="Prix..." />
            </div>
          </div>
          <button type="submit" className="btn-submit" disabled={loading}>
            {editId ? <><FaSave /> Modifier</> : <><FaPlusCircle /> Enregistrer</>}
          </button>
        </form>
      ) : (
        <>
          {loadingProduits ? (
            <div className="loading"><FaSpinner className="spinner" /></div>
          ) : (
            <table className="product-table">
              <thead>
                <tr>
                  <th>Nom</th>
                  <th>Prix</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {produits.map((p) => (
                  <tr key={p.id}>
                    <td>{p.nom}</td>
                    <td>{Number(p.prix_unitaire).toLocaleString()}</td>
                    <td className="actions-td">
                      <button className="btn-action edit" onClick={() => handleEdit(p)}><FaEdit /></button>
                      <button className="btn-action delete" onClick={() => handleDelete(p.id)}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}